/**
 *  @class
 *  @function ThemeFooter
 */

if (!customElements.get('theme-footer')) {
  class ThemeFooter extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
        button.addEventListener('click', () => {
          button.classList.toggle('active');
        });
      });

      this.querySelectorAll('.thb-arrow').forEach((arrow) => {
        let submenu = arrow.parentNode.querySelector('.sub-menu');
        arrow.addEventListener('click', (e) => {
          e.preventDefault();
          if (!submenu.classList.contains('active')) {
            submenu.classList.add('active');
          } else {
            submenu.classList.remove('active');
            arrow.blur();
          }
        });
      });

      this.animations_enabled =
        document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

      if (document.body.classList.contains('template-product-quick-view')) {
        this.animations_enabled = false;
      }
      if (!this.animations_enabled) {
        return;
      }

      if (this.classList.contains('footer-reveal--true')) {
        this.setupAnimations();
      }
    }

    setupAnimations() {
      if (typeof ScrollTrigger === 'undefined') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      gsap.registerPlugin(ScrollTrigger);

      // 文案 + logo / 订阅框 / 支付图标 渐显（首次进入视口）
      const textTargets = this.querySelectorAll(
        [
          '.footer-top-image',
          '.newsletter-box',
          '.newsletter-title',
          '.newsletter-text',
          '.footer-social-links',
          '.thb-widget-title',
          '.widget--text .rte',
          '.thb-widget-menu',
          '.footer-payment-icons',
          '.sub-footer .policy-text',
          '.sub-footer .copyright-box > p'
        ].join(', ')
      );

      if (textTargets.length) {
        gsap.from(textTargets, {
          opacity: 0,
          y: 28,
          duration: 0.8,
          stagger: 0.06,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: this,
            start: 'top 85%',
            once: true
          }
        });
      }
    }
  }

  customElements.define('theme-footer', ThemeFooter);
}
